export default "__VITE_ASSET__BZVtcFub__"